module.exports = __webpack_public_path__ + "img/q_40_sor.f0ecb6a2.png";